import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainComponent } from './core/components/main/main.component';
import { authGuard } from './auth/guards/auth.guard';
import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found.component';
import { routeChildGuard, routeGuard } from './auth/guards/route.guard';

const routes: Routes = [
  { path: '', redirectTo: 'app', pathMatch: 'full' },
  { path: 'auth', loadChildren: () => import(`./auth/auth.module`).then((module) => module.AuthModule), canActivate: [authGuard] },
  {
    path: 'app',
    component: MainComponent,
    canActivate: [routeGuard],
    children: [
      { path: '', redirectTo: 'get-insights', pathMatch: 'full' },
      {
        path: 'get-insights',
        loadChildren: () => import('src/app/features/data-insight/data-insight.module').then((a) => a.DataInsightModule),
        canActivate: [authGuard, routeChildGuard],
      },
      {
        path: 'simulation',
        loadChildren: () => import('src/app/features/simulation/simulation.module').then((a) => a.SimulationModule),
        canActivate: [authGuard, routeChildGuard],
      },
      {
        path: 'kpi-dashboard',
        loadChildren: () => import('./features/kpi-dashboard/kpi-dashboard.module').then((m) => m.KpiDashboardModule),
        canActivate: [authGuard, routeChildGuard],
      },
      {
        path: 'scenario-comparison',
        loadChildren: () => import('./features/scenario-comparison/scenario-comparison.module').then((m) => m.ScenarioComparisonModule),
        canActivate: [authGuard, routeChildGuard],
      },
      {
        path: 'analysis-insights',
        loadChildren: () => import('./features/analysis-insight/analysis-insight.module').then((m) => m.AnalysisInsightsModule),
        canActivate: [authGuard, routeChildGuard],
      },
      { path: 'map-view', loadChildren: () => import('./features/map-view/map-view.module').then((m) => m.MapViewModule), canActivate: [authGuard, routeChildGuard] },
      { path: 'logger-view', loadChildren: () => import('./features/logger-view/logger-view.module').then((m) => m.LoggerViewModule), canActivate: [authGuard, routeChildGuard] },
    ],
  },
  { path: 'mdm', loadChildren: () => import('./features/mdm/mdm.module').then((m) => m.MDMModule), canActivate: [authGuard] },
  { path: '**', component: PageNotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
